<template>
  <v-container fluid>
    <v-row :style="{ marginTop: day_select == 'single' ? '-20px' : '-20px' }">
      <v-col cols="1" lg="1" md="1" style="margin-left: 50px;" />
      <v-col cols="11" lg="8" md="8">
        <span style="color: #0A7EA5; font-size: 16px; cursor: pointer;" @click="getBackList()" class="hover-back">
          &lt;Back
        </span>
      </v-col>
    </v-row>
    <v-row :style="{ marginTop: day_select == 'single' ? '-40px' : '-50px' }">
      <v-col cols="10" lg="7" md="7" style="margin-left:  auto; margin-right: auto;">
        <v-row>
          <v-col cols="12" lg="12" md="12" class="d-flex align-center justify-end">
            <v-avatar size="35">
              <v-icon dark style="color: #808080 ; font-size: 35px;" v-if="image_show == ''">
                mdi-account-circle
              </v-icon>
              <v-img v-else :lazy-src="leave_data.images" max-height="35" max-width="35"
                :src="leave_data.images"></v-img>
            </v-avatar>
            <span style="color: #222222; font-size: 20px; padding-left: 15px;">{{ this.fullName }}</span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row style="margin-top: 20px;">
      <v-col cols="10" lg="7" md="7" style="margin-left:  auto; margin-right: auto;">
        <v-row>
          <v-col cols="12" lg="12" md="12" class="d-flex">
            <v-row>
              <v-col cols="6" lg="6" md="6">
                <span style="color: #222222; font-size: 25px; font-weight: 500;">Approve Time Off</span>
              </v-col>
              <v-col cols="6" lg="6" md="6" class="d-flex align-center justify-end">
                <span style="color: #ffbe5c; font-size: 14px">Pending</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row :style="{ marginTop: day_select == 'single' ? '10px' : '0px' }">
      <v-col cols="10" lg="7" md="7" style="margin-left:  auto; margin-right: auto;" class="d-flex">
        <v-row>
          <v-col cols="6" lg="6" md="6" style="padding-right: 30px;">
            <span style="color: #222222; font-size: 18px;">Leave Type</span>
            <v-select class="pt-2" v-model="leave_data.leaveTypeId" label="Leave Type" fluid item-text="leave_type"
              item-value="leave_type_id" :items="dropdownLeave" outlined dense disabled></v-select>
          </v-col>
          <v-col cols="6" lg="6" md="6" style="padding-left: 30px;" v-if="day_select == 'single'">
            <v-row class="align-end">
              <v-col cols="6" lg="6" md="6">
                <span style="color: #222222; font-size: 18px;">Date</span>
                <v-menu ref="menu_start" v-model="menu_start" :close-on-content-click="false" :return-value.sync="date"
                  transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field class="pt-2" v-model="computedDateFromFormatted" append-icon="mdi-calendar" readonly
                      v-bind="attrs" v-on="on" outlined dense disabled></v-text-field>
                  </template>
                  <v-date-picker v-model="leave_data.startDate" no-title scrollable />
                </v-menu>
              </v-col>
              <v-col cols="6" lg="6" md="6">
                <v-select class="pt-2" v-model="leave_start_hours" fluid item-text="text" item-value="value"
                  :items="leave_hours" outlined dense disabled></v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row :style="{ marginTop: day_select == 'single' ? '-30px' : '-30px ' }" v-if="day_select == 'multiple'">
      <v-col cols="10" lg="7" md="7" style="margin-left:  auto; margin-right: auto;" class="d-flex">
        <v-row>
          <v-col cols="6" lg="6" md="6" style="padding-right: 30px;">
            <v-row class="align-end">
              <v-col cols="6" lg="6" md="6">
                <span style="color: #222222; font-size: 18px;">From</span>
                <v-menu ref="menu_start" v-model="menu_start" :close-on-content-click="false" :return-value.sync="date"
                  transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field class="pt-2" v-model="computedDateFromFormatted" append-icon="mdi-calendar" readonly
                      v-bind="attrs" v-on="on" outlined dense disabled></v-text-field>
                  </template>
                  <v-date-picker v-model="leave_data.startDate" no-title scrollable />
                </v-menu>
              </v-col>
              <v-col cols="6" lg="6" md="6">
                <v-select class="pt-2" v-model="leave_start_hours" fluid item-text="text" item-value="value"
                  :items="leave_hours" outlined dense disabled></v-select>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6" lg="6" md="6" style="padding-left: 30px;">
            <v-row class="align-end">
              <v-col cols="6" lg="6" md="6">
                <span style="color: #222222; font-size: 18px;">To</span>
                <v-menu ref="menu_end" v-model="menu_end" :close-on-content-click="false" :return-value.sync="date"
                  transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field class="pt-2" v-model="computedDateToFormatted" append-icon="mdi-calendar" readonly
                      v-bind="attrs" v-on="on" outlined dense disabled></v-text-field>
                  </template>
                  <v-date-picker v-model="leave_data.endDate" no-title scrollable />
                </v-menu>
              </v-col>
              <v-col cols="6" lg="6" md="6">
                <v-select class="pt-2" v-model="leave_end_hours" fluid item-text="text" item-value="value"
                  :items="leave_hours" outlined dense disabled></v-select>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row :style="{ marginTop: day_select == 'single' ? '-30px' : '-30px ' }" v-if="!day_select">
      <v-col cols="10" lg="7" md="7" style="margin-left:  auto; margin-right: auto;" class="d-flex">
        <v-row>
          <v-col cols="6" lg="6" md="6" style="padding-right: 30px;">
            <v-row class="align-end">
              <v-col cols="6" lg="6" md="6">
                <span style="color: #222222; font-size: 18px;">From</span>
                <v-menu ref="menu_start" v-model="menu_start" :close-on-content-click="false" :return-value.sync="date"
                  transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field class="pt-2" v-model="computedDateFromFormatted" append-icon="mdi-calendar" readonly
                      v-bind="attrs" v-on="on" outlined dense disabled></v-text-field>
                  </template>
                  <v-date-picker v-model="leave_data.startDate" no-title scrollable />
                </v-menu>
              </v-col>
              <v-col cols="6" lg="6" md="6">
                <v-text-field class="pt-2" v-model="str_m_time" outlined dense disabled></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="6" lg="6" md="6" style="padding-left: 30px;">
            <v-row class="align-end">
              <v-col cols="6" lg="6" md="6">
                <span style="color: #222222; font-size: 18px;">To</span>
                <v-menu ref="menu_end" v-model="menu_end" :close-on-content-click="false" :return-value.sync="date"
                  transition="scale-transition" offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field class="pt-2" v-model="computedDateToFormatted" append-icon="mdi-calendar" readonly
                      v-bind="attrs" v-on="on" outlined dense disabled></v-text-field>
                  </template>
                  <v-date-picker v-model="leave_data.endDate" no-title scrollable />
                </v-menu>
              </v-col>
              <v-col cols="6" lg="6" md="6">
                <v-text-field class="pt-2" v-model="end_m_time" outlined dense disabled></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row style="margin-top: -30px;">
      <v-col cols="10" lg="7" md="7" style="margin-left:  auto; margin-right: auto;" class="d-flex">
        <v-row>
          <v-col cols="12" lg="12" md="12">
            <span style="color: #222222; font-size: 16px;">({{ this.amountShow }})</span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row :style="{
      marginTop: day_select == 'single' ? '10px' : '0px',
      marginBottom: day_select == 'single' ? '30px' : '0px',
    }">
      <v-col cols="10" lg="7" md="7" style="margin-left:  auto; margin-right: auto;" class="d-flex">
        <v-row>
          <v-col cols="12" lg="12" md="12">
            <v-textarea outlined v-model="leave_data.description" disabled rows="2"></v-textarea>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row :style="{ marginTop: day_select == 'single' ? '-50px' : '-30px ' }" v-if="oldpreview_list.length > 0">
      <v-col cols="10" lg="7" md="7" style="margin-left:  auto; margin-right: auto; " class="d-flex">
        <v-card style="width: 100%;">
          <template>
            <div class="border pa-10">
              <template>
                <v-row class="your-target-div-here" id="mydiv">
                  <v-col v-for="(item, index) in oldpreview_list" :key="index" class="d-flex child-flex" cols="3">
                    <v-img disabled :src="item" class="grey lighten-2 mt-3 mb-5" aspect-ratio="1" contain
                      @click="deleteItemConfirm(item)">
                    </v-img>
                    <!-- <p class="mb-0">file name: {{ image_list[index].name }}</p>
                        <p>size: {{ image_list[index].size / 1024 }}KB</p> -->
                  </v-col>
                </v-row>

                <template>
                  <div>
                    <!--  :pdf-margin="20"
                          pdf-content-width="720px" -->
                    <vue-html2pdf :show-layout="false" :float-layout="true" :enable-download="true"
                      :preview-modal="false" :paginate-elements-by-height="1100" filename="meeting_vote_report"
                      :pdf-quality="2" :manual-pagination="false" pdf-format="a4" pdf-orientation="portrait"
                      @progress="onProgress($event)" @hasStartedGeneration="hasStartedGeneration()"
                      @hasGenerated="hasGenerated($event)" ref="html2Pdf">
                      <!-- :html-to-pdf-options="htmlToPdfOptions" -->
                      <section slot="pdf-content">
                        <v-row>
                          <v-col v-for="(item, index) in oldpreview_list" :key="index" class="d-flex child-flex"
                            cols="12">
                            <v-img eager disabled :src="item" class="grey lighten-2 mt-3 mb-5" aspect-ratio="1" contain>
                            </v-img>
                          </v-col>
                        </v-row>

                        <!-- PDF Content Here -->
                      </section>
                    </vue-html2pdf>
                  </div>
                </template>
              </template>
            </div>
          </template>
        </v-card>
      </v-col>
    </v-row>

    <v-row :style="{ marginTop: oldpreview_list.length > 0 ? '20px' : '-30px' }">
      <v-col cols="10" lg="7" md="7" style="margin-left:  auto; margin-right: auto;" class="d-flex">
        <v-row>
          <v-col cols="12" lg="12" md="12">
            <v-textarea ref="description" outlined v-model="leave_data.description_approve" label="Note"
              rows="2"></v-textarea>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <div>
      <v-row>
        <v-col align="center" cols="12" md="12">
          <v-btn depressed class="mr-5" style="
                    color: white;
                    background-color: #0A7EA5;
                    width: 200px;
              " @click="onSave">
            Approve
          </v-btn>

          <v-btn depressed class="mr-5" style="
                color: red;
                width: 200px;
                border: 1px solid red;
              " @click="onReject">
            Reject Leave
          </v-btn>
        </v-col>
        <v-col align="center" cols="12" md="2"> </v-col>
      </v-row>
    </div>

    <v-dialog v-model="dialogDelete" scrollable max-width="50%">
      <v-card>
        <!-- <v-card-title class="text-h5"
                      >Are you sure you want to delete this item?</v-card-title
                    > -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn right color="red" text @click="closeDelete">
            <v-icon x-large color="red">mdi-close</v-icon></v-btn>
        </v-card-actions>
        <v-img :src="imageshowpopup" class="grey lighten-2 mt-3 mb-5" aspect-ratio="1" contain>
        </v-img>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogSave" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Are you sure ?</v-card-title>
        <br />
        <v-card-subtitle>
          <span class="black--text">Do you really want to send this leave request? This process cannot
            be undone.</span>
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeSave">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="onSave">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogReject" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Are you sure ?</v-card-title>
        <br />
        <v-card-subtitle>
          <span class="black--text">Do you really want to send this leave request? This process cannot
            be undone.</span>
        </v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeReject">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="onReject">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />
    <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message" :link="link" />
  </v-container>
</template>

<script>
import api from "@/services/api";
import { server, imageUrl } from "@/services/constants";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import SuccessDialog from "@/components/cards/SuccessDialog";
import html2pdf from "html2pdf.js";
import VueHtml2pdf from "vue-html2pdf";
import unity from "@/unity/unity";

export default {
  name: "approve-leave-confirm",
  components: { SuccessDialogPush, SuccessDialog, VueHtml2pdf },
  data(vm) {
    return {
      str_m_time: "",
      end_m_time: "",
      image_show: "",
      day_select: "multiple",
      leave_hours: [
        { text: "1 hour", value: 1 },
        { text: "2 hours", value: 2 },
        { text: "3 hours", value: 3 },
        { text: "Half day", value: 4 },
        { text: "5 hours", value: 5 },
        { text: "6 hours", value: 6 },
        { text: "7 hours", value: 7 },
        { text: "Full day", value: 8 },
      ],
      menu_start: false,
      menu_end: false,
      leave_start_hours: "",
      leave_end_hours: "",
      dialogConfirm: false,
      approve_end_flow_status: false,
      approve_detail_data: [],
      imageshowpopup: "",
      fullName: "",
      employee_id: "",
      dialogDelete: false,
      dialogSave: false,
      dialogReject: false,
      preview: null,
      image: null,
      preview_list: [],
      oldpreview_list: [],
      image_list: [],
      menu: false,
      menu2: false,
      search: "",
      toggleEnable: false,
      selectstatus: "",
      dropdownLeave: [],
      dataAll: [],
      mDataArray: [],
      amountShow: "",
      headers: [
        {
          text: "Period",
          value: "period",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Leave Type",
          value: "leave_type",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Quota (Day)",
          value: "quota_day",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Used",
          value: "user_day",
          class: "bg-colorth tabletextwhite",
        },
        {
          text: "Balance (Day)",
          value: "balance",
          class: "bg-colorth tabletextwhite",
        },
      ],
      leave_data: {
        leaveType: 0,
        leaveTypeId: 0,
        approve_id_now: 0,
        startDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        endDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10),
        description: "",
        description_approve: "",
        userId: 0,
        departmentId: 0,
        companyId: 0,
        amount: 0,
        images: null,
        lq_id: 0,
      },
      dateCurrent: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dialogAdd: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
    };
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  computed: {
    computedDateFromFormatted() {
      return unity.formatDate(this.leave_data.startDate);
    },
    computedDateToFormatted() {
      return unity.formatDate(this.leave_data.endDate);
    },
  },
  async beforeCreate() {
    this.$store.state.navMenu = true;
  },
  async mounted() {
    await api.checkVersion();
    this.$store.state.global_dialog_push = false;
    this.$store.state.global_dialog = false;

    this.userId = localStorage.getItem(server.USER_ID);

    await this.loaddataLeaveUsed(this.$route.params.employee_id);
    await this.loadLeaveApproveDetail();

    this.$hideLoader();
  },

  methods: {
    async getBackList() {
      this.$router.push(`/approver-time-off`);
    },
    async loadLeaveApproveDetail() {
      // const res = await api.getListApproveDetailByRequestId(
      const res = await api.getListApproveDetailNoZeroIdByRequestId(
        this.$route.params.id,
      );

      this.approve_detail_data = res.data;

    },
    exportToPDF() {
      this.$refs.html2Pdf.generatePdf();
    },
    async onDialogSave() {
      this.dialogSave = true;
    },
    async onDialogReject() {
      this.dialogReject = true;
    },
    async onSave() {
      this.dialogSave = false;

      var count_approve = 0;
      var user_approve_id = 0;
      var approve_id = 0;
      var user_approve_id_next = 0;
      var now_index = 0;
      var next_index = 0;
      var next_status = false;
      var flow_end_status = false;

      count_approve = this.approve_detail_data.length;

      this.approve_detail_data.forEach(async (item, index) => {
        if (!next_status) {
          if (item.status == 1) {
            now_index = index;
            next_index = index + 1;
            next_status = true;
            user_approve_id = item.approve_id;
            approve_id = item.id;
          }
        }
      });
      //   approve_id = this.approval_status[next_index].approve_id;

      if (now_index == count_approve - 1) {
        flow_end_status = true;
        user_approve_id = localStorage.getItem(server.USER_ID);
      } else {
        user_approve_id_next = this.approve_detail_data[next_index].approve_id;
      }


      this.leave_data.userId = localStorage.getItem(server.USER_ID);

      var save_data = {
        leave_id: this.$route.params.id,
        approve_detail_id: approve_id,
        user_approve_id: user_approve_id,
        user_approve_id_next: user_approve_id_next,
        flow_end_status: flow_end_status,
        approval_remark: this.leave_data.description_approve,
      };


      // var body = {
      //   status: status,
      //   leave_type_id: this.leave_data.leaveTypeId,
      //   employee_id: this.employee_id,
      //   userId: localStorage.getItem(server.USER_ID),
      //   description_approve: this.leave_data.description_approve,
      // };

      this.$showLoader();

      // const res_h = await api.updateApprove(this.$route.params.id, body);
      const res_save = await api.saveApproval(save_data);
      // if (res_h.status == 200 || res_h.status == 201) {
      if (res_save.data.save_sta) {
        api.SendnotificationToMobile({
          user_id: parseInt(this.$route.params.employee_id),
          send_mode: "send_to_requester_approved",
        });

        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "Time Off Approved",
          "You have approved this request.",
          "text-h5 green--text text-center",
          "/approver-time-off",
        );
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "บันทึกข้อมูลไม่สำเร็จ",
          "text-h5 red--text text-center",
        );
      }
      this.$hideLoader();
    },
    async onReject() {
      if (this.leave_data.description_approve == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Please enter all the details.",
          "text-h5 red--text text-center",
        );
        this.$refs["description"].focus();
        return;
      }

      var request_master_id = this.$route.params.id;

      var save_data = {
        request_master_id: parseInt(request_master_id),
        user_action: parseInt(localStorage.getItem(server.USER_ID)),
        approval_remark: this.leave_data.description_approve,
      };

      this.$showLoader();

      const res_save = await api.saveReject(save_data);

      this.$hideLoader();

      if (res_save.data.save_sta) {
        api.SendnotificationToMobile({
          user_id: parseInt(this.$route.params.employee_id),
          send_mode: "send_to_requester_rejected",
        });

        this.$store.state.global_push_dialog = true;
        this.setupAlertDialogPush(
          true,
          "Time Off Rejected",
          "You have rejected this request.",
          "text-h5 green--text text-center",
          "/approver-time-off",
        );
      } else {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Failed",
          "Save data Failed",
          "text-h5 red--text text-center",
        );
      }
    },

    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    saveItemConfirm() {
      this.dialogSave = true;
    },
    closeSave() {
      this.dialogSave = false;
    },
    closeReject() {
      this.dialogReject = false;
    },
    deleteItemConfirm(data) {
      // this.indeximage = index;
      this.imageshowpopup = data;
      this.dialogDelete = true;
    },
    closeDelete() {
      this.indeximage = null;
      this.dialogDelete = false;
    },
    async removeimage(index) {
      this.preview_list.splice(this.indeximage, 1);
      this.image_list.splice(this.indeximage, 1);

      this.dialogDelete = false;
    },

    async loaddataLeaveUsed(id) {
      const result = await api.getListUseByUserIDV2byCompany(
        id,
        localStorage.getItem(server.COMPANYID),
      );
      // console.log("loaddataLeaveUsedloaddataLeaveUsedloaddataLeaveUsedloaddataLeaveUsed")
      // console.log(result.data)

      var data = [];

      result.data.forEach((item) => {
        var obj = {
          leave_type_id: 1,
          use_leave: "0.0625",
          leave_period_from: "2021-12-31T17:00:00.000Z",
          leave_period_to: "2022-12-30T17:00:00.000Z",
          leave_type: "ลาป่วย",
          quota_day: "30.0000",
          user_day: "0.0625",
          balance: "29.9375",
        };

        obj.use_leave = item.use_leave;
        obj.leave_period_from = item.leave_period_from;
        obj.leave_period_to = item.leave_period_to;
        obj.leave_type = item.leave_type;
        obj.period = item.period;
        obj.quota_day = this.quotaListConvert(item.quota_day);
        obj.user_day = this.quotaListConvert(item.user_day);
        obj.balance = this.quotaListConvert(item.balance);

        data.push(obj);
      });

      this.dataAll = data;

      const result_dropsown = await api.getListByUserIDV3byCompany(
        id,
        localStorage.getItem(server.COMPANYID),
      );

      //       console.log("getListByUserIDV3byCompany:");
      // console.log(result_dropsown.data);
      this.dropdownLeave = result_dropsown.data;



      const res_data = await api.getListApproveByRequestID(
        this.$route.params.id,
      );

      // console.log(`getListApproveByRequestIDgetListApproveByRequestID`);
      //  console.log(res_data.data);
      this.mDataArray = res_data.data;

      this.mDataArray.forEach((x, index) => {
        this.leave_data.leaveTypeId = Number(x.leavetypeid);
        this.leave_data.approve_id_now = x.approve_id_now;

        // แปลง startdate และ enddate เป็นรูปแบบที่ถูกต้อง
        // สำหรับ v-date-picker ต้องการรูปแบบ YYYY-MM-DD
        this.leave_data.startDate = this.convertToISODate(x.startdate);
        this.leave_data.endDate = this.convertToISODate(x.enddate);

        this.day_select = x.type_count;

        // แก้ไขตัวแปรให้ตรงกับข้อมูลที่ได้จาก API (starthour ไม่ใช่ startHour)
        this.leave_start_hours = Number(x.starthour);
        this.leave_end_hours = Number(x.endhour);

        this.leave_data.description = x.description;
        this.leave_data.amount = x.amount;
        this.leave_data.leaveType = x.leave_type;
        this.leave_data.lq_id = x.lq_id;

        // แสดงเวลาในรูปแบบที่อ่านง่าย
        this.str_m_time = this.formatDateTime(x.startdate);
        this.end_m_time = this.formatDateTime(x.enddate);

        this.image_show = x.image;
        if (x.image == "" || x.image == null) {
          this.leave_data.images = imageUrl + "/personal.png";
        } else {
          this.leave_data.images = imageUrl + "/" + x.image;
        }

        if (x.fullName_eng != " ") {
          this.fullName = x.fullname_eng;
        } else {
          this.fullName = x.fullname;
        }
        this.employee_id = x.employee_id;

        let setiamggfile = x.preview_image ? x.preview_image.split(",") : [];
        if (setiamggfile[0] == "") {
        } else {
          setiamggfile.forEach((x) => {
            this.oldpreview_list.push(
              `${imageUrl}/${x}`,
            );
          });
        }
      });

      this.amountShow = this.quotaListConvert(this.leave_data.amount / 8);
    },

    // เพิ่ม helper methods ใหม่
    convertToISODate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      // แปลงเป็นรูปแบบ YYYY-MM-DD สำหรับ v-date-picker
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    formatDateTime(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);

      // Format: DD/MM/YYYY HH:mm
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");

      return `${day}/${month}/${year} ${hours}:${minutes}`;
    },

    formatDateOnly(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    },

    formatTimeOnly(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${hours}:${minutes}`;
    },

    quotaListConvert: function (H) {
      var d = 0;
      var h = 0;
      var m = 0;
      var tmp1 = parseFloat(H * 8);
      var tmp_final;

      var tmp_d = tmp1 / 480;

      d = Math.floor(tmp_d);
      h = Math.floor((tmp_d - d) * 8);
      m = Math.floor(((tmp_d - d) * 8 - h) * 60);

      tmp_final = `${d} Day ${h} Hour`;

      return tmp_final;
    },

    previewMultiImage: function (event) {
      var input = event.target;
      var count = input.files.length;
      var index = 0;
      if (input.files) {
        while (count--) {
          var reader = new FileReader();
          reader.onload = (e) => {
            this.preview_list.push(e.target.result);
          };
          if (input.files[index].type.split("/")[0] === "image") {
            this.image_list.push(input.files[index]);
            reader.readAsDataURL(input.files[index]);
          }
          index++;
        }
      }
    },
  },
};
</script>

<style scoped>
.hover-back {
  transition: color 0.3s ease;
  /* เพิ่มการเคลื่อนไหว */
}

.hover-back:hover {
  color: #6edbff !important;
  /* เปลี่ยนเป็นสีน้ำเงินเข้มเมื่อ hover */
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.v-textarea:not(.v-textarea--round).v-size--default.buttongreen {
  background-color: #09b534;
  color: white;
}

.textarea {
  border: 2px solid;
  border-color: #09b534;
}

.heightsize55 {
  height: 55px;
}

.heightsize80 {
  height: 80px;
}

.heightsize30 {
  height: 30px;
}

.inputsize {
  font-size: smaller;
}

.btnuploadfile {
  border: 2px solid;
}

.heightsize70formadvance {
  height: 70px;
}
</style>
